
import { Suspense, useEffect } from "react";
import Hero from "@/components/Hero";
import FeatureSection from "@/components/FeatureSection";
import FeaturedOffers from "@/components/FeaturedOffers";
import FeaturedCustomPackages from "@/components/FeaturedCustomPackages";
import FeaturedSellers from "@/components/FeaturedSellers";
import RecentRequests from "@/components/RecentRequests";
import Testimonials from "@/components/Testimonials";
import CTASection from "@/components/CTASection";
import ErrorBoundary from "@/components/ErrorBoundary";
import { isSupabaseInitialized } from "@/integrations/supabase/client";
import OpenGraphImage from "@/components/common/OpenGraphImage";

const SafeSection = ({ children, name }: { children: React.ReactNode; name: string }) => {
  console.log(`Rendering ${name} component`);
  
  return (
    <ErrorBoundary fallback={
      <div className="p-8 border border-red-200 bg-red-50 rounded-lg m-4">
        <h3 className="font-semibold text-red-600">Error in {name}</h3>
        <p className="text-sm text-gray-600">This section failed to load.</p>
      </div>
    }>
      <Suspense fallback={
        <div className="p-8 border border-gray-200 bg-gray-50 rounded-lg m-4 animate-pulse">
          <p className="text-center text-gray-500">Loading {name}...</p>
        </div>
      }>
        {children}
      </Suspense>
    </ErrorBoundary>
  );
};

const Index = () => {
  console.log("Index page rendering");
  console.log("Supabase initialized:", isSupabaseInitialized());
  
  useEffect(() => {
    console.log("Index page mounted");
    
    // Check for required components
    if (!Hero) console.warn("Hero component is not defined");
    if (!FeatureSection) console.warn("FeatureSection component is not defined");
    if (!FeaturedOffers) console.warn("FeaturedOffers component is not defined");
    if (!FeaturedCustomPackages) console.warn("FeaturedCustomPackages component is not defined");
    if (!FeaturedSellers) console.warn("FeaturedSellers component is not defined");
    if (!RecentRequests) console.warn("RecentRequests component is not defined");
    if (!Testimonials) console.warn("Testimonials component is not defined");
    if (!CTASection) console.warn("CTASection component is not defined");
    
    return () => {
      console.log("Index page unmounted");
    };
  }, []);
  
  return (
    <div className="index-page">
      <OpenGraphImage 
        title="BackLink Hub - SEO Link Marketplace"
        description="Buy and sell premium SEO backlinks in a transparent marketplace"
        image="/og-images/home.png"
      />
      
      <SafeSection name="Hero">
        <Hero />
      </SafeSection>
      
      <SafeSection name="FeatureSection">
        <FeatureSection />
      </SafeSection>
      
      <SafeSection name="FeaturedOffers">
        <FeaturedOffers />
      </SafeSection>
      
      <SafeSection name="FeaturedCustomPackages">
        <FeaturedCustomPackages />
      </SafeSection>
      
      <SafeSection name="RecentRequests">
        <RecentRequests />
      </SafeSection>
      
      <SafeSection name="FeaturedSellers">
        <FeaturedSellers />
      </SafeSection>
      
      <SafeSection name="Testimonials">
        <Testimonials />
      </SafeSection>
      
      <SafeSection name="CTASection">
        <CTASection />
      </SafeSection>
    </div>
  );
};

export default Index;
